import ComponentBase from "@components/ComponentBase";
import { ComponentElem } from "@components/interfaces";

type State = "" | "normal" | "error" | "ok";

export default class SimpleInput extends ComponentBase
{
  $errorHint: any;

  constructor(elem: ComponentElem)
  {
    super(elem);

    this.$errorHint = this.$root.find(".error-hint");
  }

  toggleState(state: State, errorText: string = "")
  {
    this.$root.attr("state", state);

    if (state === "error") {
      this.$errorHint.text(errorText);
    }
  }
}